export default __webpack_public_path__ + "static/markedwax-3c5066da93ac6c2cdcfc0026e28e0c72.png";